export default __webpack_public_path__ + "static/Bg-ios-dubai-559f6187920f105a280ed0a0ef2d3b4f.webp";